export default __webpack_public_path__ + "static/media/Oval-Turquoise-Beaded-Diffuser-Stretch-Bracelet.a2d7d51d.jpg";